/* Site Popovers
========================================================= */


const initPopovers = () => {

	const popovers = document.querySelectorAll('.popover-trigger');

	if (!popovers.length) return;

	popovers.forEach((popover) => {

		const showPopover = (event) => {
			let currentParent = popover.parentNode;
			let currentPopover = event.target;
			let currentData = currentPopover.dataset.popoverSrc;
			let popoverImage = document.createElement("img");
			let popoverContainer = document.createElement("div");
			popoverContainer.className = "popover-container";
			popoverImage.src = currentData; // set img src
			popoverContainer.appendChild(popoverImage);
			currentPopover.appendChild(popoverContainer);
		}
		const hidePopover = (event) => {
			let openPopover = document.getElementsByClassName('popover-container');
			if (openPopover.length > 0) {
				openPopover[0].remove();
			}
		}
		const hidePopoverTouch = (event) => {
			const popupTrigger = event.target;
			let openPopover = document.getElementsByClassName('popover-container');
			if (!popupTrigger.classList.contains('popover-trigger')) {
				openPopover[0].remove();
			}
		}

		popover.addEventListener('mouseover', showPopover);
		popover.addEventListener('mouseout', hidePopover);
		popover.addEventListener('touchstart', hidePopoverTouch);

	});
}

export { initPopovers };